export default __webpack_public_path__ + "static/1277-675af5ad8ddfd74bacda293bb828183b.gif";